import { api } from "@/lib/axios";
import type {
  ApiResponse,
  RecvocTenantListResult,
  RecvocTenantListItem,
  IssueRecvocTenantRequest,
  IssueRecvocTenantResponse,
  UpdateRecvocTenantRequest,
} from "../types/recvocTenant.types";

export const listRecvocTenants = async (
  companyGuid: string,
): Promise<RecvocTenantListResult> => {
  const { data } = await api.get<ApiResponse<RecvocTenantListResult>>(
    "/api/cti/recvoc-tenants",
    { params: { companyGuid } },
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const issueRecvocTenant = async (
  req: IssueRecvocTenantRequest,
): Promise<IssueRecvocTenantResponse> => {
  const { data } = await api.post<ApiResponse<IssueRecvocTenantResponse>>(
    "/api/cti/recvoc-tenants",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const revokeRecvocTenant = async (idx: number): Promise<void> => {
  const { data } = await api.post<ApiResponse<boolean>>(
    `/api/cti/recvoc-tenants/${idx}/revoke`,
    {},
  );
  if (data.code !== 200) throw new Error(data.message);
};

export const updateRecvocTenant = async (
  idx: number,
  req: UpdateRecvocTenantRequest,
): Promise<RecvocTenantListItem> => {
  const { data } = await api.post<ApiResponse<RecvocTenantListItem>>(
    `/api/cti/recvoc-tenants/${idx}`,
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};
